import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Linkedin } from "lucide-react";

export default function TrainersPage() {
  const [trainers, setTrainers] = useState([]);
  useEffect(() => { api.get("/trainers").then(({ data }) => setTrainers(data)); }, []);

  return (
    <div className="pt-12 pb-24">
      <div className="container-eq">
        <div className="max-w-3xl">
          <div className="label-eq text-sky-500 mb-3">Our Team</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tighter" data-testid="trainers-title">Meet your trainers</h1>
          <p className="mt-4 text-neutral-600">Industry-experienced practitioners who've been where you want to go.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {trainers.map((t) => (
            <div key={t.id} className="card-eq p-6" data-testid={`trainer-${t.id}`}>
              <div className="aspect-square rounded-xl overflow-hidden bg-neutral-100 mb-4">
                {t.image && <img src={t.image} alt={t.name} className="w-full h-full object-cover" />}
              </div>
              <div className="font-display font-bold text-lg">{t.name}</div>
              <div className="text-sm text-sky-600 font-semibold">{t.role}</div>
              {t.bio && <p className="text-sm text-neutral-600 mt-2 line-clamp-3">{t.bio}</p>}
              {t.expertise?.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-3">
                  {t.expertise.map((e, i) => <span key={i} className="text-xs bg-neutral-100 rounded-full px-2 py-1">{e}</span>)}
                </div>
              )}
              {t.linkedin && (
                <a href={t.linkedin} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1 text-sm text-neutral-600 hover:text-sky-500">
                  <Linkedin className="w-4 h-4" /> LinkedIn
                </a>
              )}
            </div>
          ))}
        </div>
        {trainers.length === 0 && <div className="text-center text-neutral-500 py-16">Trainers profiles coming soon.</div>}
      </div>
    </div>
  );
}
